export default __webpack_public_path__ + "static/media/atomicWalletIcon.37ed70ee.svg";